import api from '../../utils/api';
import {
    LOGIN,
    LOGOUT,
    GET_AUTH_USER,
    CHANGE_PASSWORD,
    RESET_PASSWORD,
    UPDATE_AUTH_USER,
    CHANGE_PIN_CODE,
    RESET_PIN_CODE
} from './types';
import { setCookie, removeCookie } from '../../utils/cookie';
import { NotificationManager } from 'react-notifications';

export const login = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/login', data).then(res => {
            //console.log(res.data.data) // Get token
            if (data.remember) {
                setCookie('chingo_dental_token', res.data.data.token, 1);
            } else {
                setCookie('chingo_dental_token', res.data.data.token, 1);
            }

            dispatch({ type: LOGIN, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            let message = "Đã có lỗi xảy ra, vui lòng thử lại!";
            if (err.response.data.msg) message = err.response.data.msg;
            NotificationManager.error(message);
            reject(err);
        })
    })
}

export const getAuthUser = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/auth').then(res => {
            //console.log("REs: ",res.data.data)
            dispatch({ type: GET_AUTH_USER, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            //console.log(err.response)
            // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
            reject(err);
        })
    })
}

export const updateAuthUser = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put('/auth', data).then(res => {
            dispatch({ type: UPDATE_AUTH_USER, payload: res.data.data });
            NotificationManager.success("Cập nhật thành công!");
            resolve(true)
        }).catch(err => {
            //console.log(err.response)
            // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
            reject(err);
        })
    })
}

export const changePassword = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/change-password', data).then(res => {
            dispatch({ type: CHANGE_PASSWORD, payload: res.data.data });
            NotificationManager.success("Thay đổi mật khẩu thành công!");
            resolve(true)
        }).catch(err => {
            let message = "Đã có lỗi xảy ra, vui lòng thử lại!";
            if (err.response.data.msg) message = err.response.data.msg;
            NotificationManager.error(message);
            reject(err);
        })
    })
}

export const changePinCode = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/change-pin-code', data).then(res => {
            dispatch({ type: CHANGE_PIN_CODE, payload: res.data.data });
            NotificationManager.success("Thay đổi mã pin thành công!");
            resolve(true)
        }).catch(err => {
            let message = "Đã có lỗi xảy ra, vui lòng thử lại!";
            if (err.response.data.msg) message = err.response.data.msg;
            NotificationManager.error(message);
            reject(err);
        })
    })
}

export const resetPassword = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/reset-password', data).then(res => {
            dispatch({ type: RESET_PASSWORD, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            //console.log(err);
            let message = "Đã có lỗi xảy ra, vui lòng thử lại!";
            if (err.response.data.msg) message = err.response.data.msg;
            NotificationManager.error(message);
            reject(err);
        })
    })
}

export const resetPincode = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/reset-pin-code').then(res => {
            dispatch({ type: RESET_PIN_CODE, payload: res.data.data });
            resolve(true)
        }).catch(err => {
            //console.log(err);
            let message = "Đã có lỗi xảy ra, vui lòng thử lại!";
            if (err.response.data.msg) message = err.response.data.msg;
            NotificationManager.error(message);
            reject(err);
        })
    })
}

export const logout = () => dispatch => {
    return new Promise((resolve, reject) => {
        removeCookie('chingo_dental_token');
        dispatch({ type: LOGOUT });
        resolve(true);
    })
}